import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "fs14"
  }, [_c('TableTopBox', {
    attrs: {
      "title": _vm.title
    }
  }, [_vm.hasSearchParams ? _c('ElButton', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function click($event) {
        _vm.showSearch = !_vm.showSearch;
      }
    }
  }, [_c('i', {
    class: [_vm.showSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down']
  }), _vm._v(" " + _vm._s(_vm.showSearch ? "隐藏搜索" : "展开搜索") + " ")]) : _vm._e(), _vm._t("top-right")], 2), _vm.hasSearchParams ? _c('ElCollapseTransition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSearch,
      expression: "showSearch"
    }]
  }, [_c('div', {
    staticClass: "search-bar flex flex-wrap"
  }, [_vm._l(_vm.renderList || _vm.demoList, function (it) {
    return _c('div', {
      key: it.key,
      staticClass: "sb-item mr20"
    }, [_c('div', {
      staticClass: "sb-tip"
    }, [_vm._v(_vm._s(it.tip) + " :")]), it.type === 'input' || it.type === 'date' ? [it.type === 'input' ? _c('Input', _vm._b({
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "size": "small",
        "clearable": ""
      },
      model: {
        value: _vm.params[it.key],
        callback: function callback($$v) {
          _vm.$set(_vm.params, it.key, typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "params[it.key]"
      }
    }, 'Input', it.props, false)) : _c('DatePicker', _vm._b({
      staticStyle: {
        "width": "360px"
      },
      attrs: {
        "size": "small",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        "clearable": ""
      },
      model: {
        value: _vm.params[it.key],
        callback: function callback($$v) {
          _vm.$set(_vm.params, it.key, $$v);
        },
        expression: "params[it.key]"
      }
    }, 'DatePicker', it.props, false))] : it.type === 'radio' || it.type === 'checkbox' ? [_c('RadioGroup', _vm._b({
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "size": "small"
      },
      model: {
        value: _vm.params[it.key],
        callback: function callback($$v) {
          _vm.$set(_vm.params, it.key, $$v);
        },
        expression: "params[it.key]"
      }
    }, 'RadioGroup', it.props, false), _vm._l(it.opts, function (opt) {
      return _c('Radio', {
        key: opt.value
      }, [_vm._v(_vm._s(opt.label))]);
    }), 1), _c('CheckboxGroup', _vm._b({
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "size": "small"
      },
      model: {
        value: _vm.params[it.key],
        callback: function callback($$v) {
          _vm.$set(_vm.params, it.key, $$v);
        },
        expression: "params[it.key]"
      }
    }, 'CheckboxGroup', it.props, false), _vm._l(it.opts, function (opt) {
      return _c('Checkbox', _vm._b({
        key: opt.value
      }, 'Checkbox', opt, false));
    }), 1)] : it.type === 'select' ? [_c('Select', _vm._b({
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "size": "small",
        "clearable": "",
        "filterable": ""
      },
      model: {
        value: _vm.params[it.key],
        callback: function callback($$v) {
          _vm.$set(_vm.params, it.key, $$v);
        },
        expression: "params[it.key]"
      }
    }, 'Select', it.props, false), _vm._l(it.opts, function (opt) {
      return _c('Option', _vm._b({
        key: opt.value
      }, 'Option', opt, false));
    }), 1)] : [_vm._t(it.type)]], 2);
  }), _c('div', {
    staticClass: "sb-item mr20 sb-actions"
  }, [_c('ElButton', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('search');
      }
    }
  }, [_vm._v(" 搜索 ")]), _c('ElButton', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('reset');
      }
    }
  }, [_vm._v("重置")])], 1)], 2)])]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };